import { createContext, useContext, useEffect, useRef } from 'react';
export const KeyboardArbitrationContext = createContext(null);
/** Adds one live candidate to Composer's ordered arrow-key arbitration. */
export function useKeyboardArbitrationCandidate(candidate) {
    const registry = useContext(KeyboardArbitrationContext);
    const candidateRef = useRef(candidate);
    candidateRef.current = candidate;
    useEffect(() => {
        if (registry === null)
            throw new Error('Keyboard candidate mounted outside arbitration host');
        return registry.register({
            priority: candidate.priority,
            onKeyDown: (event, key) => candidateRef.current.onKeyDown(event, key),
        });
    }, [candidate.priority, registry]);
}
//# sourceMappingURL=keyboardArbitration.js.map